import { number, oneOfType, string } from 'prop-types';
import React from 'react';
import protectCopyRight from '../helpers/protectCopyRight';

export default function HeroSlideshowItem({ backgroundUrl, itemWidth, id }) {
    return (<div
        className={'hero-slideshow__item'}
        style={{ width: `${itemWidth}%` }}>
        <img
            onContextMenu={protectCopyRight}
            src={backgroundUrl}
            alt={`slider image ${id}`} />
    </div>);
}

HeroSlideshowItem.propTypes = {
    backgroundUrl: string,
    id: number,
    itemWidth: oneOfType([number, string]),
};